"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlwaysDelay = void 0;
const delay_base_1 = require("../delay.base");
class AlwaysDelay extends delay_base_1.Delay {
}
exports.AlwaysDelay = AlwaysDelay;
